import { IconButtonStyled } from "./iconButtonStyled";
import CloseIcon from '@mui/icons-material/Close';
import { FC } from "react";

const CloseButton:FC<{onClick:()=>void}> = ({onClick,...props}) => {

    return (
        <IconButtonStyled onClick={onClick} size="small" {...props}>
            <CloseIcon />
        </IconButtonStyled>
    )
}
export default CloseButton;